import { useEffect } from 'react';
import { INDUSTRIES_API } from '../Utils/apis';
import { useDispatch } from 'react-redux';
import { addIndustries } from '../Store/Slices/industries';

const useFetchIndustries = (isAuthenticated) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (!isAuthenticated) return;
        (async () => {
            try {
                const res = await fetch(INDUSTRIES_API, { credentials: 'include' });
                if (res.ok) {
                    const data = await res.json();
                    dispatch(addIndustries(data?.data));
                }
            } catch (err) {}
        })();
    }, [isAuthenticated]);
};

export default useFetchIndustries;
